import { createContext, useState, useContext, ReactNode } from 'react'
import { updateAppStatusBar } from '../../utils/appBridge'
import { getTopPadding } from '../../utils/sessionStorage'

type AppBarScrimTheme = 'light' | 'dark' | null

interface AppBarScrimContextType {
  appBarTheme: AppBarScrimTheme
  handleSetAppBarTheme: (theme: AppBarScrimTheme) => void
}

export const AppBarScrimContext = createContext<AppBarScrimContextType | null>(null)

export const useAppBarScrim = () => {
  const context = useContext(AppBarScrimContext)
  if (!context) {
    throw new Error('useAppBarScrim must be used within a AppBarScrimProvider')
  }
  return context
}

export const AppBarScrimProvider = ({ children }: { children: ReactNode }) => {
  const [appBarTheme, setAppBarTheme] = useState<AppBarScrimTheme>(null)

  const handleSetAppBarTheme = (theme: AppBarScrimTheme) => {
    const topPadding = getTopPadding()
    if (topPadding > 0) {
      setAppBarTheme(theme)
    }
    updateAppStatusBar(theme === 'light' ? '000000' : 'FFFFFF', theme === 'light' ? 'light' : 'dark', true)
  }

  return (
    <AppBarScrimContext.Provider value={{ appBarTheme, handleSetAppBarTheme }}>
      {appBarTheme && (
        <div
          className='absolute z-10 top-0 left-0 right-0'
          style={{ height: getTopPadding() + 30, pointerEvents: 'none' }}
        >
          {/* Light theme scrim */}
          <div
            style={{
              background: 'linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.8) 100%)',
              opacity: appBarTheme === 'light' ? 1 : 0,
              transition: 'opacity 0.15s ease-in-out',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              height: '100%'
            }}
          ></div>
          {/* Dark theme scrim */}
          <div
            style={{
              background:
                'linear-gradient(to top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0.8) 100%)',
              opacity: appBarTheme === 'dark' ? 1 : 0,
              transition: 'opacity 0.15s ease-in-out',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              height: '100%'
            }}
          ></div>
        </div>
      )}
      {children}
    </AppBarScrimContext.Provider>
  )
}
